// extracted by mini-css-extract-plugin
module.exports = {"photoPost":"UserPhotoPost_photoPost__17JfR","file":"UserPhotoPost_file__1dV0G","preview":"UserPhotoPost_preview__1c1eA"};